import React from 'react';
import { ViewDSL } from './types';

// Core exports
export { DezzyCompiler } from './compiler';
export { DezzyValidator } from './validator';
export { DezzyProvider, DezzyView, useDezzy, createSection } from './components';

// Agent exports
export { DezzyAgent, createAgentContext } from './agent';

// Governance exports
export { GovernanceEngine, defaultGovernance } from './governance';

// UI exports
export { SplitPane, ChatInterface, StorybookEmbed, AgentUI } from './ui';

// Examples exports
export { 
  buttonSectionManifest,
  cardSectionManifest,
  inputSectionManifest,
  exampleManifests,
  validateManifest
} from './examples';

// Hooks exports
export { useAgentOperations, useProjectData } from './hooks';

// State exports
export { useAgentStore, useProjectData as useProjectDataStore, useChatState, useUIState } from './state/agent-store';

// Providers exports
export { AgentProvider } from './providers';

// Type exports
export type {
  ViewDSL,
  Section,
  SectionRegistry,
  SectionManifest,
  SectionVariant,
  ViewMeta,
  Layout,
  GridLayout,
  StackLayout,
  GridPosition,
  DezzyProviderProps,
  DezzyViewProps,
  ValidationResult,
  CompilationResult,
} from './types';

// Agent type exports
export type {
  AgentContext,
  AgentOperation,
  AgentResponse
} from './agent';

// Governance type exports
export type {
  GovernanceRule,
  GovernanceContext,
  GovernanceReport
} from './governance';

// UI type exports
export type {
  SplitPaneProps,
  ChatMessage,
  ChatInterfaceProps,
  StorybookEmbedProps,
  AgentUIProps
} from './ui';

// Hooks type exports
export type {
  UseAgentOperationsOptions,
  ProjectData,
  UseProjectDataOptions
} from './hooks';

// State type exports  
export type {
  AgentState,
  AgentActions,
  AgentStore
} from './state/agent-store';

// Providers type exports
export type {
  AgentProviderProps
} from './providers';

// Note: Design tokens are generated by the CLI scaffolding process
// They will be available in generated projects at src/tokens/

// Utility functions
export function createRegistry(sections: Record<string, React.ComponentType<any>>) {
  return sections;
}

export function loadViewDSL(json: string | object): ViewDSL {
  if (typeof json === 'string') {
    return JSON.parse(json);
  }
  return json as ViewDSL;
}